import roleUtils from '@utils/role.utils';

function bind(el: Element, binding: any) {
    const { type, role } = binding.value || {};
    if (type) {
        const canVisible = roleUtils.includeRoleWithStore(type, role);
        canVisible ? el.classList.remove('no-role') : el.classList.add('no-role');
    } else {
        throw new Error(`need roles! Like v-role`);
    }
}

function unbind(el: Element) {
    el.classList.remove('no-role');
}

export default {
    name: 'role',
    mounted: bind,
    updated: function (el: Element, binding: any) {
        if (binding.value === binding.oldValue) return;
        bind(el, binding);
    },
    unmounted: unbind
};
